/**
 * PlaygroundSettings Component
 *
 * Settings panel for playground run configuration:
 * - Browser type dropdown (tetra, anchor, surfsky)
 * - Use proxy toggle
 * - UI-only settings (not persisted between sessions)
 */

import React from 'react';

interface PlaygroundSettingsProps {
  browserType: string;
  useProxy: boolean;
  model: string;
  gateway: string;
  onBrowserTypeChange: (browserType: string) => void;
  onUseProxyChange: (useProxy: boolean) => void;
  onModelChange: (model: string) => void;
  onGatewayChange: (gateway: string) => void;
  disabled?: boolean;
}

const BROWSER_TYPES = [
  { value: 'stealth', label: 'TinyFish' },
  { value: 'headless', label: 'TinyFish Light' },
  { value: 'tetra-plus', label: 'Stealth+' },
  { value: 'kernel', label: 'Kernel' },
  { value: 'tetra', label: 'Tetra' },
  { value: 'tetra-anchor', label: 'Stealth' },
];

const MODELS = [
  { value: 'gemini-3-flash-preview', label: 'Gemini-3' },
  { value: 'supernova', label: 'Gemini-3-lite' },
  { value: 'cerebras/gpt-oss-120b', label: 'OSS' },
];

const GATEWAYS = [
  { value: 'default', label: 'Python' },
  { value: 'go', label: 'Go' },
];

export const PlaygroundSettings: React.FC<PlaygroundSettingsProps> = ({
  browserType,
  useProxy,
  model,
  gateway,
  onBrowserTypeChange,
  onUseProxyChange,
  onModelChange,
  onGatewayChange,
  disabled = false,
}) => {
  return (
    <div className="flex items-center gap-3 mb-2.5 flex-wrap">
      {/* Model Selector */}
      <div className="flex items-center gap-2">
        <select
          id="model"
          value={model}
          onChange={(e) => onModelChange(e.target.value)}
          disabled={disabled}
          className="px-2 py-1 border border-gray-300 rounded text-xs focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed bg-white"
          aria-label="Select model"
        >
          {MODELS.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

    </div>
  );
};
